<template>
  <Toaster
    theme="light"
    position="bottom-center"
    class="tw:[font-family:inherit]!"
    :container-aria-label="t('nkf.notifications')"
    :toast-options="{
      descriptionClass: 'tw:type-body! tw:text-primary-foreground!',
      classes: {
        icon: 'tw:m-0!',
        title: 'tw:type-body-strong! tw:text-primary-foreground!',
        content: 'tw:min-w-0! tw:break-words',
        warning: 'tw:bg-(--warning-strong)! tw:border-(--warning-strong)!',
        error: 'tw:bg-(--destructive)! tw:border-(--destructive)!',
      },
      class:
        'tw:inset-x-0! tw:mx-auto! tw:w-fit! tw:max-w-[92%]! tw:gap-2! tw:whitespace-normal tw:break-words tw:text-primary-foreground! tw:px-[18px]! tw:py-3! tw:type-body tw:shadow-(--shadow-toast)!',
    }"
    :offset="{ bottom: '110px' }"
    :mobile-offset="{ bottom: '110px', left: '0px', right: '0px' }"
  />
</template>

<script setup>
// 1. Import necessary components
import { h, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue-sonner';
import { Toaster } from './ui/sonner';
import AppIcon from './AppIcon.vue';
import { onToast, offToast } from '@/shared/utilities/feedback/toast-service';
// 2. Use
const { t } = useI18n();
// 3. Define a reactive variable
const severityMethods = {
  success: toast.success,
  error: toast.error,
  warn: toast.warning,
  info: toast.info,
};
const severityIcons = { success: 'check', info: 'info', warn: 'alert', error: 'alert' };
// 4. Define methods or computed properties if needed
function show({ severity, summary, detail, key, icon, life }) {
  severityMethods[severity](summary, {
    id: key,
    description: detail,
    duration: life,
    icon: h(AppIcon, { name: icon || severityIcons[severity], size: 'action' }),
  });
}
// 5. VueJS Hooks
onToast(show);
onBeforeUnmount(() => {
  offToast(show);
  toast.dismiss();
});
</script>
